module.exports = __webpack_public_path__ + "img/icon-wallet.73b7a9f9.svg";